<template>
    <main class="content">
        <EnterReferralUIDModal @submit="signUp" @skip="signUp(null, true)" />
        <RecaptchaV3 ref="recaptchaV3" />
        <RecaptchaV2 @verify="signUp" />
        <ReferralService />

        <div ref="twitchExample" />
        <!-- FB PLUGINS -->
        <div id="fb-root" />
        <!-- FB PLUGINS -->
        <section class="box-main-screen">
            <div class="wrapper">
                <div class="screen-cont">
                    <div class="screen-cont__title">
                        Earn extra cash doing what you like to do!
                    </div>
                    <div class="box-form">
                        <div
                            class="fb-like"
                            data-href="https://www.facebook.com/uniquerewards/"
                            data-action=""
                            data-size=""
                            data-share=""
                        />
                        <div v-if="!auth" class="box-form__title">
                            Join UniqueRewards for FREE and get $5 Bonus right
                            away!
                        </div>

                        <form v-if="!auth" @submit.prevent="signUp">
                            <div class="row">
                                <div class="col">
                                    <div class="box-field">
                                        <input
                                            v-model="form.email.value"
                                            type="text"
                                            class="form-control"
                                            placeholder="E-mail"
                                        />
                                        <div
                                            :class="{
                                                'invalid-feedback d-block':
                                                    form.email.verified
                                                    === 'no',
                                            }"
                                            v-text="form.email.errorMsg"
                                        />
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="box-field">
                                        <div class="password-input">
                                            <input
                                                v-model="form.pwd.value"
                                                :type="passwordVisible ? 'text' : 'password'"
                                                class="form-control"
                                                placeholder="Password"
                                            />
                                            <button
                                                type="button"
                                                class="show-password-button"
                                                @click="togglePasswordVisibility"
                                            >
                                                <span v-if="passwordVisible">
                                                    <i class="fas fa-eye-slash" />
                                                </span>
                                                <span v-else>
                                                    <i class="fas fa-eye" />
                                                </span>
                                            </button>
                                        </div>
                                        <div
                                            :class="{
                                                'invalid-feedback d-block':
                                                    form.pwd.verified === 'no',
                                            }"
                                            v-text="form.pwd.errorMsg"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="button-form">
                                <input
                                    type="button"
                                    class="button button_orange button_large"
                                    value="Sign up for free"
                                    @click="signUp()"
                                />
                            </div>
                            <LoginSocials
                                @error="setErrorMessageSignUp"
                                @success="signUpComplete"
                            />

                            <div
                                class="align-items-left d-flex flex-column justify-content-center my-3 invalid-feedback"
                            >
                                {{ errorMessageSignUp }}
                            </div>
                        </form>
                    </div>
                </div>
                <ul
                    class="d-flex justify-content-center flex-wrap service-list"
                >
                    <li class="service-1 service-list__item">
                        <router-link
                            :to="$Trans.i18nRoute({ name: 'surveys' })"
                            class="service-list__link"
                        >
                            <span class="table">
                                <span class="table-cell">
                                    <img src="@assets/img/icon_1.png" alt />
                                    <span class="service-list__text">
                                        Take Surveys
                                    </span>
                                </span>
                            </span>
                        </router-link>
                    </li>
                    <li class="service-list__item service-2">
                        <router-link
                            :to="$Trans.i18nRoute({ name: 'offer-walls' })"
                            class="service-list__link"
                        >
                            <span class="table">
                                <span class="table-cell">
                                    <img src="@assets/img/icon_2.png" alt />
                                    <span class="service-list__text">
                                        Offer Walls
                                    </span>
                                </span>
                            </span>
                        </router-link>
                    </li>
                    <li class="service-list__item service-4">
                        <router-link
                            :to="$Trans.i18nRoute({ name: 'paid-2-games' })"
                            class="service-list__link"
                        >
                            <span class="table">
                                <span class="table-cell">
                                    <img src="@assets/img/icon_4.png" alt />
                                    <span class="service-list__text">
                                        Paid 2 Games
                                    </span>
                                </span>
                            </span>
                        </router-link>
                    </li>
                    <li class="service-list__item service-5">
                        <router-link
                            :to="$Trans.i18nRoute({ name: 'video' })"
                            class="service-list__link"
                        >
                            <span class="table">
                                <span class="table-cell">
                                    <img src="@assets/img/icon_5.png" alt />
                                    <span class="service-list__text">
                                        Watch Videos
                                    </span>
                                </span>
                            </span>
                        </router-link>
                    </li>
                    <li class="service-list__item service-7">
                        <router-link
                            :to="$Trans.i18nRoute({ name: 'click' })"
                            class="service-list__link"
                        >
                            <span class="table">
                                <span class="table-cell">
                                    <img src="@assets/img/icon_7.png" alt />
                                    <span class="service-list__text">
                                        Visit Sites
                                    </span>
                                </span>
                            </span>
                        </router-link>
                    </li>
                </ul>
            </div>
            <div class="box-site-tour">
                <div class="site-tour">
                    <div class="online-since">
                        <div class="online-since__text">
                            Online since
                            <strong>2003</strong>
                        </div>
                        <div class="icon icon_date" />
                    </div>
                    <a href="#" class="button button_large d-none">
                        <span class="icon icon_watch" />
                        Watch Site Tour
                    </a>
                    <div class="active-user">
                        <div class="icon icon_user" />
                        <div class="active-user__text">
                            <strong>500 000 +</strong>
                            <br />
                            active users
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="how-it-work">
            <div class="wrapper">
                <h1>How it works?</h1>
                <ul class="how-it-work__list">
                    <li class="how-it-work__item">
                        <div class="how-it-work__icon">
                            <img src="@assets/img/work_icon_1.png" alt />
                        </div>
                        <div class="how-it-work__text">
                            Fill in registration form
                        </div>
                    </li>
                    <li class="how-it-work__item">
                        <div class="how-it-work__icon">
                            <img src="@assets/img/work_icon_2.png" alt />
                        </div>
                        <div class="how-it-work__text">
                            Complete easy tasks
                            <br />
                            offers, surveys
                        </div>
                    </li>
                    <li class="how-it-work__item">
                        <div class="how-it-work__icon">
                            <img src="@assets/img/work_icon_3.png" alt />
                        </div>
                        <div class="how-it-work__text">
                            Cash out
                        </div>
                    </li>
                </ul>
            </div>
        </section>
        <section class="bg-white box-gallery">
            <div class="wrapper">
                <div class="subtitle">
                    Doubt and don't believe. Check the proofs.
                </div>
                <div id="carousel-1" class="w-100 pt-3">
                    <Slick ref="slick" :options="slickOptions">
                        <button
                            v-for="(slideSrc, index) in paymentScreens"
                            :key="index"
                            href="#"
                            class="slick-info-payments"
                            @click.prevent="showSlide($event.target, slideSrc)"
                        >
                            <img :src="slideSrc" alt="" />
                        </button>
                    </Slick>
                </div>
            </div>
        </section>
        <section class="box-testimonials">
            <div>
                <h2>Testimonials</h2>
                <div class="subtitle white">
                    Check our video testimonials and what our users say
                </div>
                <div class="testomanials-block">
                    <ul class="testomanials-block__list">
                        <li
                            v-for="(video, index) in videos"
                            :key="index"
                            class="testimonials-video__item"
                        >
                            <a
                                href="#"
                                class="testimonials-video__link"
                                @click.prevent="
                                    $modal.show('facebook-modal-video-' + index)
                                "
                            >
                                <img width="150px" height="150px" :src="video.screenAsset" :alt="video.alt" />
                                <span
                                    class="testimonials-video__icon"
                                />
                            </a>
                            <Modal
                                :name="'facebook-modal-video-' + index"
                                height="400px"
                                adaptive
                            >
                                <div
                                    class="align-items-center d-flex justify-content-center facebook-video-wrap"
                                    style="background: #000"
                                >
                                    <video :src="video.videoAsset" controls class="facebook-video-frame" />
                                </div>
                                <a
                                    href="#"
                                    class="modal-close text-muted border-0 bg-transparent"
                                    @click.prevent="
                                        $modal.hide(
                                            'facebook-modal-video-' + index,
                                        )
                                    "
                                >
                                    <i class="fa fa-2x fa-times" />
                                </a>
                            </Modal>
                        </li>
                    </ul>
                    <div class="fb-widget">
                        <!-- FB PLUGIN PAGE -->
                        <div
                            class="fb-page"
                            data-href="https://www.facebook.com/uniquerewards"
                            data-tabs="timeline"
                            data-width="320px"
                            data-height="600px"
                            data-small-header="false"
                            data-adapt-container-width="true"
                            data-hide-cover="false"
                            data-show-facepile="true"
                        >
                            <blockquote
                                cite="https://www.facebook.com/uniquerewards"
                                class="fb-xfbml-parse-ignore"
                            >
                                <a
                                    href="https://www.facebook.com/uniquerewards"
                                >
                                    Facebook
                                </a>
                            </blockquote>
                        </div>
                        <!-- FB PLUGIN PAGE -->
                    </div>
                </div>
            </div>
        </section>

        <section class="box-join-free">
            <div class="wrapper">
                <div class="screen-cont">
                    <div class="screen-cont__title">
                        Join for free
                        <br />
                        and get $5 bonus!
                    </div>
                    <div class="box-form">
                        <form v-if="!auth">
                            <div class="row">
                                <div class="col">
                                    <div class="box-field">
                                        <input
                                            v-model="form.email.value"
                                            type="text"
                                            class="form-control"
                                            placeholder="E-mail"
                                        />
                                        <div
                                            :class="{
                                                'invalid-feedback d-block':
                                                    form.email.verified
                                                    === 'no',
                                            }"
                                            v-text="form.email.errorMsg"
                                        />
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="box-field">
                                        <input
                                            v-model="form.pwd.value"
                                            type="password"
                                            class="form-control"
                                            placeholder="Password"
                                        />
                                        <div
                                            :class="{
                                                'invalid-feedback d-block':
                                                    form.pwd.verified === 'no',
                                            }"
                                            v-text="form.pwd.errorMsg"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="button-form">
                                <input
                                    type="button"
                                    class="button button_large button_orange"
                                    value="Sign up for free"
                                    @click="signUp()"
                                />
                            </div>
                            <LoginSocials
                                @error="setErrorMessageSignUp"
                                @success="signUpComplete"
                            />

                            <div
                                class="align-items-left d-flex flex-column justify-content-center my-3 invalid-feedback d-block"
                            >
                                {{ errorMessageSignUp }}
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
        <section class="box-our-partners">
            <div class="wrapper">
                <h2>Our partners</h2>
                <ul class="js-logos partner-list">
                    <li class="partner-list__item">
                        <a href="#">
                            <img src="@assets/img/logo_1.png" alt />
                        </a>
                    </li>
                    <li class="partner-list__item">
                        <a href="#">
                            <img src="@assets/img/logo_2.png" alt />
                        </a>
                    </li>
                    <li class="partner-list__item">
                        <a href="#">
                            <img src="@assets/img/logo_3.png" alt />
                        </a>
                    </li>
                    <li class="partner-list__item">
                        <a href="#">
                            <img src="@assets/img/logo_4.png" alt />
                        </a>
                    </li>
                    <li class="partner-list__item">
                        <a href="#">
                            <img src="@assets/img/logo_5.png" alt />
                        </a>
                    </li>
                    <li class="partner-list__item">
                        <a href="#">
                            <img src="@assets/img/logo_6.png" alt />
                        </a>
                    </li>
                    <li class="partner-list__item">
                        <a href="#">
                            <img src="@assets/img/logo_7.png" alt />
                        </a>
                    </li>
                </ul>
            </div>
        </section>
    </main>
</template>
<script>
import LoginSocials from '~/views/components/LoginSocials.vue';
import { Validation } from 'utils/validation';
import axios from 'axios';

import { videos } from 'db/videos';
import { slickOptions } from 'db/slick-options';
import { paymentScreens } from 'db/payment-screens';

import { mapGetters } from 'vuex';

import 'slick-carousel/slick/slick.css';
import Slick from 'vue-slick';
import { isBrokerReferralLink, isFullSignUpForm } from '~/utils/helpers';
import EnterReferralUIDModal from '~/views/EnterReferralUIDModal.vue';
import RecaptchaV3 from './components/RecaptchaV3.vue';
import RecaptchaV2 from './components/RecaptchaV2.vue';
import ReferralService from './components/ReferralService.vue';

export default {
    components: {
        EnterReferralUIDModal,
        LoginSocials,
        Slick,
        RecaptchaV3,
        RecaptchaV2,
        ReferralService,
    },
    expose: [],
    data() {
        return {
            validation: new Validation(),
            videos,
            slickOptions,
            paymentScreens,
            lastTransactions: [],
            errorMessageSignUp: '',
            passwordVisible: false,
            form: {
                fp_val: {
                    value: '',
                    required: true,
                    errorMsg: '',
                    verified: 'pending',
                },
                pwd: {
                    value: '',
                    required: true,
                    errorMsg: '',
                    verified: 'pending',
                },
                email: {
                    value: '',
                    required: true,
                    errorMsg: '',
                    verified: 'pending',
                },
                'g-recaptcha-response': {
                    value: '',
                    required: true,
                    errorMsg: '',
                    verified: 'pending',
                },
            },
        };
    },
    computed: {
        ...mapGetters(['auth', 'user']),
    },
    mounted() {
        const script = document.createElement('script');
        script.src = 'https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v8.0';
        script.setAttribute('nonce', 'cEYmXiKr');
        script.setAttribute('crossorigin', 'anonymous');
        script.setAttribute('defer', '');
        document.head.append(script);

        // LAST TRANSACTIONS LIST
        this.getLastTransactions();
    },
    methods: {
        collectReferralData() {
            const data = {};

            const urRefid = localStorage.getItem('urRefid');

            if (urRefid) {
                data.refid = urRefid;
            }

            const urBid = localStorage.getItem('urBid');
            const urSubid1 = localStorage.getItem('urSubid1');
            const urSubid2 = localStorage.getItem('urSubid2');
            const urSubid3 = localStorage.getItem('urSubid3');

            if (urBid) {
                data.bid = urBid;
                data.subid1 = urSubid1;
                data.subid2 = urSubid2;
                data.subid3 = urSubid3;
            }

            return data;
        },
        async signUp(recaptchaResponse, skipReferralEnterModal) {
            this.form.fp_val.value = this.$store.getters.visitorId;
            this.form['g-recaptcha-response'].value = recaptchaResponse || (await this.$refs.recaptchaV3.verify());

            this.validation.check(this.form);

            if (this.validation.status !== 'done') return;

            const referralData = this.collectReferralData();
            if (!skipReferralEnterModal) {
                if (!referralData.refid && !referralData.bid) {
                    this.$modal.show('enter-referral-uid');
                    return;
                }
            }

            await this.$Trans.localeConfirmUser();

            if ((await isFullSignUpForm()) || isBrokerReferralLink()) {
                this.$store.dispatch('updateUserData', {
                    email: this.form.email.value,
                    pwd: this.form.pwd.value,
                });
                this.$store.dispatch('changeRegistrationStep', 2);
                await this.$router.push(
                    this.$Trans.i18nRoute({ name: 'register' }),
                );

                return;
            }

            axios
                .post('/service/signup', {
                    email: this.form.email.value,
                    pwd: this.form.pwd.value,
                    fp_val: this.form.fp_val.value,
                    'g-recaptcha-response':
                        this.form['g-recaptcha-response'].value,
                    cv: recaptchaResponse ? '2' : '3',
                    locale: this.$Trans.currentLocale,
                    ...referralData,
                })
                .then(
                    (response) => {
                        const _response = JSON.parse(
                            response.request.responseText,
                        );
                        if (_response.error && _response.error === '0') {
                            this.$modal.show('register-info');
                            this.$store.dispatch('authentication', {
                                status: true,
                                token: _response.result.token,
                            });
                            this.$store.dispatch(
                                'updateUserData',
                                _response.result,
                            );
                            this.$store.dispatch('changeRegistrationStep', 1);
                            this.signUpComplete();
                        }
                    },
                    ({ response }) => {
                        if (response.data?.error === '109') {
                            this.form.email.errorMsg = `Email ${this.form.email.value} has been taken by another user. Please try another email.`;
                            this.form.email.verified = 'no';
                        }

                        if (response.data.error === '133') {
                            this.$modal.show('captcha');
                        }
                    },
                );
        },
        showSlide(eventTarget, slideSrc) {
            this.$modal.show(
                {
                    template:
                        '<img :src="slideSrc" style="height: auto; width: 100%; max-width: 600px; max-height: 90dvh; object-fit: contain;">',
                    props: ['slideSrc'],
                },
                {
                    slideSrc,
                },
                { adaptive: true, height: 'auto' },
            );
        },
        showVideo(name) {
            this.$modal.show(name);
        },
        getLastTransactions() {
            axios
                .get('/service/getLastTrans')
                .then((response) => {
                    try {
                        const _response = JSON.parse(
                            response.request.responseText,
                        );
                        if (_response.result) {
                            this.lastTransactions = _response.result;
                        }
                    } catch (e) {}
                })
                .catch((err) => {});
        },
        setErrorMessageSignUp(message) {
            this.errorMessageSignUp = message.errorMessage;
        },
        signUpComplete() {
            this.$store.dispatch('getUserData');
            this.$router.push(this.$Trans.i18nRoute({ name: 'hot-offers' }));
        },
        togglePasswordVisibility() {
            this.passwordVisible = !this.passwordVisible;
        },
    },
};
</script>

<style lang="scss">
#carousel-1 {
    height: 450px;
    position: relative;

    .slick-slider {
        height: 100%;
    }

    .slick-info-payments {
        height: auto;
        width: auto;
        background: none;
        border: none;
        height: 400px;
        display: flex !important;
        align-items: center;
        justify-content: center;
    }

    .slick-list {
        height: 100%;
    }

    .slick-track {
        height: 80%;
        padding: 30px 0;
    }
    .slick-arrow {
        position: absolute;
        top: 50%;
        z-index: 1;
        width: 44px;
        height: 83px;
        font-size: 0;
        border: none !important;
        outline: none !important;

        &:active {
            border: none !important;
            outline: none !important;
        }

        &.slick-next {
            right: 0px;
            transform: translateY(-50%);
            background: url(data:image/png;base64,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)
                no-repeat top left;
        }

        &.slick-prev {
            left: 0px;
            transform: translateY(-50%) scale(-1, 1);
            background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAACpCAYAAABQ+d9qAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA25pVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDozRkY0NTY2OTdBMEJFNjExOEY5MEFFQkQwQkZGQjk2NSIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDoxODQ5Mjc0ODdFRjcxMUU2QkFDMUZGRUY3OEE1QzFGNyIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDoxODQ5Mjc0NzdFRjcxMUU2QkFDMUZGRUY3OEE1QzFGNyIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ0MgMjAxNSAoV2luZG93cykiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo3YmFiNGQyZi1hZWZmLWFkNDgtYmQwZS03YTYxOGNkYWIzOTUiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6M0ZGNDU2Njk3QTBCRTYxMThGOTBBRUJEMEJGRkI5NjUiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4bmwPxAAACnklEQVR42uzbSW7CQBCFYVyKuB7nyAGyzCrLHCDnyPWywEEJRsbQdru7XtUrqbwBedLH6PEfxnE8RBpepifvn1/jx9vrcHl0BV0Mq9Nlws4fmQe5vqphNm6kB0dCy+L7Q4+WJ+Oo0VIYT4uWlWmUaNmYToeWinmo0FI5Hw1adsxLgZad87ujpWEZV7Q0LueGlo5lXdDSubw5WhTWYYoWpfWYoUVxXSZoUV4fHC2AdULRAvrkYGgB/j4gaCQYgkaD1dEWYFW0FVgNbQlWQVuDu9Ee4C60F7gZ7QluQnuDd6MZwHforZPqLOBqNBO4Cs0Gvjup/gxNB95CU4LX0LTgEpoaPH9nJ7xEwtKCS1hK8BqWEbyKZQNvYpnAVVgW8FjY1aQE78J6g3djPcFNWC9wM9YD3IW1BndjLcEqWCuwGtYCrIpFg9WxSDAEiwLDsAgwFKsNhmM1wSZYLbAZVgNsiu0Fm2N7wC7YVrAbtgXsit0LdsfuAVNga8E02BowFXYLTIddA1NiS2Ba7AN4cYmJDnsHjoC9gaNgb+DpJPLWyWSGYYhWLMoh2JDgBC+GW3Ur3z8j+1/a+XT8f4ev2OVmmforEa+6jYJe/uiyurX6W8vq1mrDkdWt1aY5q1urnZ+sbq12L7O6tdqBz+rW6hApq1urg9Csbq0O87O6tQBD0FndotFZ3aLRWd2i0VndotFZ3aLRlNXtGpq2ui2hGa8iraJZL3sV0czX6Z6i2S8sPqDZwQ/3cUgkLDO4eIeMRMIygjfvPZJIWCZw9V1dWd0isd7grG7psB7grG6psVbgrG7DYJHgrG5R4KxuUeCsblHgrG5R4KxuUeCsblHgrG5R4KxuUeCsblHgONVtBOwcHKu6PZ+OQwTsHzBadfsrwACWq+hL43nCcQAAAABJRU5ErkJggg==)
                no-repeat left top;
        }
    }

    .slick-slide {
        img {
            object-fit: contain;
            max-width: calc(100vw - 20px);
            max-height: 300px;
            border-radius: 0.5em;
            box-shadow: 0 0 5px #ccc;
            border: 1px solid #ccc;
            transition: transform 0.3s linear;
        }
    }
}

.facebook-video-wrap {
    width: 100%;
    height: 100%;

    .facebook-video-frame {
        width: 100%;
        height: 100%;
    }
}

.earned-title {
    display: flex;
    align-items: center;
    gap: 1em;
    padding-left: 0;
}

.earned-title__icon {
    min-width: 60px;
    height: 60px;
    border-radius: 50%;
    background-color: #ff9e00;
    display: flex;
    align-items: center;
    justify-content: center;
}

.earned-title__icon-picture {
    width: 2.2em;
    height: 2.2em;
    filter: invert(1);
}

.fb-widget {
    min-width: 320px;
    height: 600px
}

.testomanials-block {
    display: flex;
    padding-top: 4em;
    justify-content: center;
    align-items: center;
    align-content: center;
    justify-items: center;
    flex-direction: column;

}

.testomanials-block__list {
    display: flex;
    flex-wrap: wrap;
    gap: 2em;
    width: 22em
}

@media screen and (min-width: 768px) {
    .testomanials-block__list {
        width: 52em;
        display: flex;
        justify-content: center;
    }
}

@media screen and (min-width: 1000px) {
    .testomanials-block {
        flex-direction: row;
        align-items: unset;
    }
    .testomanials-block__list {
        width: 720px;
        gap: 0
    }
}

.fb-like {
    min-height: 2.2em;
    display: block !important;
}
</style>
